module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid login"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-10 col-sm-8 mx-auto login-form"
  }, [_c('router-link', {
    staticClass: "content-logo-principal",
    attrs: {
      "to": "/"
    }
  }, [_c('div', [_c('h1', [_c('a', {
    attrs: {
      "href": "https://royalpag.com"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "src": _vm.img
    }
  })])])])]), _vm._v(" "), (!_vm.usuario.codigoSmsVerificado) ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n              Verificação do telefone cadastrado\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center text-default-gray",
    staticStyle: {
      "font-size": "14px",
      "font-family": "Roboto"
    }
  }, [_vm._v("Por favor entre com o código enviado para seu celular.")]), _vm._v(" "), _c('div', {
    staticClass: "card-body pt-0"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('form', {
    staticClass: "well top4",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.verificarCodigoSms.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group text-default-gray text-center"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.usuario.codigoSms),
      expression: "usuario.codigoSms"
    }],
    attrs: {
      "type": "text",
      "name": "token",
      "id": "token"
    },
    domProps: {
      "value": (_vm.usuario.codigoSms)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.usuario, "codigoSms", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary send-btn float-right",
    attrs: {
      "typeof": "submit",
      "disabled": !_vm.isWholeCheckCode
    }
  }, [_c('i', {
    staticClass: "menu-icon ti-location-arrow text-white"
  })])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "row justify-content-center",
    staticStyle: {
      "margin-right": "95px"
    }
  }, [_c('b', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block mb-3",
    staticStyle: {
      "width": "200px",
      "display": "flex",
      "align-items": "center"
    },
    attrs: {
      "type": "reset",
      "disabled": !_vm.isWholeSendSms
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.solicitarNovoSms.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-comment fa-2x float-left pr-2"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "15px",
      "flex-grow": "1",
      "text-align": "left"
    }
  }, [_vm._v("Reenviar SMS")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isWholeSendSms),
      expression: "!isWholeSendSms"
    }],
    staticStyle: {
      "padding-top": "3px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.contador))])])])])])])])])])]) : ((_vm.usuario.codigoSmsVerificado && _vm.usuario.selfieStep)) ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n              Verificação efetuada com sucesso!\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    style: (_vm.color),
    attrs: {
      "type": "reset",
      "value": "Entrar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.entrar.apply(null, arguments)
      }
    }
  })])]) : ((_vm.usuario.codigoSmsVerificado && !_vm.usuario.selfieStep)) ? _c('div', [_c('h2', {
    staticClass: "text-center text-default-gray logo_h2 pb-5",
    staticStyle: {
      "font-size": "16px",
      "font-family": "Roboto"
    }
  }, [_vm._v("\n              Seu código foi verificado, estamos quase no fim\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "reset",
      "value": "Continuar"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.nextStep.apply(null, arguments)
      }
    }
  })])]) : _vm._e()], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "form-group text-default-gray text-center"
  }, [_c('label', [_vm._v("Digite o código de 6 digitos")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57be1660","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/auth/token.vue
// module id = WUd6
// module chunks = 36